export default "__VITE_ASSET__CKuRGEpF__"